import React from "react";
import { AppBar, Toolbar, Card, CardContent, Typography, useMediaQuery } from "@material-ui/core";
import AppIcon from "../views/AppIcon";
import { useWindowSize } from "react-use";
import { useTheme } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email'
import AppColors from './../colors/AppColors';
import { useParams, Redirect } from "react-router-dom";
import Routes from "../constants/Routes";

export default function VerifyEmailView(props: any) {

    const { width, height } = useWindowSize();
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down(800));
    const { email } = useParams();

    return (
        email === undefined ?
            <Redirect to={Routes.DEFAULT} />
            :
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: `url(${require('./../images/wallet_background.png')})`,
                    backgroundColor: '#121d33e1',
                    backgroundRepeat: 'none',
                    backgroundSize: 'cover'
                }}>
                <AppBar position="static"
                    elevation={0}
                    style={{
                        background: 'none'
                    }}>
                    <Toolbar>
                        <AppIcon />
                    </Toolbar>
                </AppBar>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: height
                }}>
                    <Card
                        style={{
                            width: mobileView ? width - 30 : width / 2,
                            borderRadius: 10,
                        }}>
                        <CardContent
                            style={{
                                margin: 30
                            }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                <Typography
                                    style={{
                                        fontWeight: 600,
                                        alignSelf: 'flex-start',
                                        fontSize: 20
                                    }}>
                                    Verify Your Email
                            </Typography>
                                <EmailIcon style={{
                                    height: 80,
                                    width: 80,
                                    color: AppColors.PRIMARY_COLOR,
                                    marginTop: 10,
                                    marginBottom: 10
                                }} />
                                <Typography style={{
                                    textAlign: 'center'
                                }} dangerouslySetInnerHTML={{ __html: `<span style='text-align:center;'>A verification link was sent to <b>${email}</b>. Please follow the instructions there to verify your account.</span>` }} />
                            </div>
                        </CardContent>
                    </Card>
                </div>

            </div>
    );
}